import React, {Component, useState, Fragment, useEffect} from 'react';
import {Link} from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ArrowBackIosTwoToneIcon from '@material-ui/icons/ArrowBackIosTwoTone';
import Button from '@material-ui/core/Button';
import Slider from '@material-ui/core/Slider';
import LinkIcon from '@material-ui/icons/Link';
import LinkOffIcon from '@material-ui/icons/LinkOff';

function Fuellstandswaechter() {
    

    const [fWState, setFWState] = useState([0]);
    const [fWCMState, setfWCMState] = useState([0]);


    useEffect(()=>{
        // do stuff here...
        var mqtt = require('mqtt')
        var Broker = "mqtts://testmqtt.syrconnect.de:8001";
        var options = {
            protocol: 'mqtts',
            clientId: 'EZGWebsiban' + Math.floor(Math.random() * 1000)
        };

        var Topic1 = "Dehoust/f593dcee-6cc6-11ee-b962-0242ac120002/OUT/";        

        var client  = mqtt.connect(Broker, options);

        client.on('connect', function () {
            var fwOfflineIndicator = document.getElementById("fwOffline");
            var fwOnlineIndicator = document.getElementById("fwOnline");            

            if (fwOnlineIndicator !=  null) {
                fwOfflineIndicator.classList.add('hide');   
                fwOnlineIndicator.classList.remove('hide'); 
            }         

            console.log('Füllstandswächter CONNECTED as ' + options.clientId);            
            client.subscribe(Topic1 + "data", function (err) {;
                if (!err) {
                console.log('SUBBED TOPIC: data');                             
                }
            })
        })

        client.on('message', function (topic, message) {
        // message is Buffer  
            console.log("onMessageArrived Message:" + message);
            console.log("onMessageArrived Topic:" + topic);

            // Set Data
            if (topic.endsWith('data')) 
            {      
                var fwHeight = parseInt(message);                
                var fwContainer = 330 - (fwHeight * 2.34);

                // 0% = 0 , 100% = 101
                // Container 100% = 95px / 0% = 330px / Range = 235px / 1% = 2.35px\
                // Using 2.34 to compensate for 100% being 101cm and not 100cm.
                setfWCMState(parseInt(fwHeight))
                setFWState(parseInt(fwContainer))
            }
        })

        client.on('close', function () {            
            console.log("Füllstandswächter DISCONNECTED")        
        })
    
        return () => client.end(); // <-- kill on unmount
    }, []) // <-- empty dependency array

    return (
        <div className="module-wrapper">
            <div className="distancer">
                {/* // SUBNAVIGATION */}
                <div className="subnav">
                    <div className="fltl">
                        <Link to="/Devices">
                            <Button variant="contained" color="primary" className="back-button" startIcon={<ArrowBackIosTwoToneIcon/>}>Geräte</Button>
                        </Link>
                    </div>
                    <div className="fltr">
                        <Button id="fwOnline" variant="outlined" color="primary" className="online fltr hide" disableElevation disabled startIcon={<LinkIcon/>}>Verbunden</Button>
                        <Button id="fwOffline" variant="outlined" color="primary" className="offline fltr" disableElevation disabled startIcon={<LinkOffIcon/>}>Verbindung</Button>
                    </div>
                    <div className="spacer"></div>                     
                </div>
                {/* END SUBNAVIGATION*/}  
                <div className="outer-title">
                Füllstandswächter
                </div>
                <Row>
                    <Col md="12" lg="12" xl="6">
                        <Card className="deviceCard">
                            <Card.Header>
                                <div className="card-title">Status</div>                                                  
                            </Card.Header>
                            <Card.Body>
                                <div className='FWwrapper'>
                                    <div className="FWcontainer">
                                        <div className="cPos">
                                            <div className="cc">
                                            <div className="circle one"></div>
                                            </div>
                                            <div className='FWlabel'>{fWCMState}%</div>
                                        </div>
                                        <div className="gradientContainer" style={{marginTop: fWState}}>
                                            <div className="overlay one"></div>
                                            <div className="gradient"><span className="ray1"></span><span className="ray2"></span><span className="ray3"></span><span className="ray4"></span><span className="ray5"></span><span className="ray6"></span><span className="ray7"></span><span className="ray8"></span><span className="ray9"></span><span className="ray10"></span><span className="ray11"></span><span className="ray12"></span><span className="ray13"></span><span className="ray14"></span><span className="ray15"></span><span className="ray16"></span><span className="ray17"></span><span className="ray18"></span><span className="ray19"></span><span className="ray20"></span><span className="ray21"></span><span className="ray22"></span><span className="ray23"></span><span className="ray24"></span><span className="ray25"></span><span className="ray26"></span><span className="ray27"></span><span className="ray28"></span><span className="ray29"></span><span className="ray30"></span><span className="ray31"></span><span className="ray32"></span><span className="ray33"></span><span className="ray34"></span><span className="ray35"></span><span className="ray36"></span><span className="ray37"></span><span className="ray38"></span><span className="ray1"></span><span className="ray2"></span><span className="ray3"></span><span className="ray4"></span><span className="ray5"></span><span className="ray6"></span><span className="ray7"></span><span className="ray8"></span><span className="ray9"></span><span className="ray10"></span><span className="ray11"></span><span className="ray12"></span><span className="ray13"></span><span className="ray14"></span><span className="ray15"></span><span className="ray16"></span><span className="ray17"></span><span className="ray18"></span><span className="ray19"></span><span className="ray20"></span><span className="ray21"></span><span className="ray22"></span><span className="ray23"></span><span className="ray24"></span><span className="ray25"></span><span className="ray26"></span><span className="ray27"></span><span className="ray28"></span><span className="ray29"></span><span className="ray30"></span><span className="ray31"></span><span className="ray32"></span><span className="ray33"></span><span className="ray34"></span><span className="ray35"></span><span className="ray36"></span><span className="ray37"></span><span className="ray38"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>            
                </Row>
            </div>
        </div>
    )
}

export default Fuellstandswaechter;